import * as yup from 'yup';

import {
  LC_PAGE_COMPETENCY_CHAR_LIMIT,
  LC_PAGE_SUBJECT_CHAR_LIMIT,
  LP_PAGE_OBJECTIVE_CHAR_LIMIT,
  SUMMATIVETEST_ENABLED_FORMATS,
  SUMMATIVETEST_ASSESSMENTTYPE_OPTIONS,
} from '@lessonPlanner/constants';

const charLimitTest = (limit: number) => (val: string) =>
  !val || val.length <= limit;

export const gradeLevel = yup.string().required('Please select a grade level');

export const subject = yup
  .string()
  .required('Please enter the subject')
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LC_PAGE_SUBJECT_CHAR_LIMIT),
  );

export const language = yup.string();

export const topics = yup
  .array()
  .of(
    yup.object().shape({
      topic: yup
        .string()
        .required('Please enter a topic')
        .test(
          'len',
          'You have reached the character limit',
          charLimitTest(LC_PAGE_COMPETENCY_CHAR_LIMIT),
        ),
      subtopics: yup
        .array()
        .of(
          yup
            .string()
            .test(
              'len',
              'You have reached the character limit',
              charLimitTest(LC_PAGE_COMPETENCY_CHAR_LIMIT),
            ),
        ),
    }),
  )
  .min(1, 'Please enter at least one topic');

export const format = yup
  .string()
  .required('Please select the format')
  .oneOf(SUMMATIVETEST_ENABLED_FORMATS, 'Please select a valid format');

export const assessmentTypes = yup
  .array()
  .of(yup.string())
  .min(1, 'Please select at least one Assessment Type')
  .test(
    'valid-assessment-types',
    'Please select valid assessment types',
    (value) => {
      if (!value) return false;
      return value.every((item) =>
        SUMMATIVETEST_ASSESSMENTTYPE_OPTIONS.includes(item),
      );
    },
  );

export const curriculumFramework = yup
  .string()
  .required('Please enter the framework');

export const curriculum = yup.string().required('Please select the curriculum');

export const specificStandards = yup
  .string()
  .required('Please enter the standard')
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LC_PAGE_SUBJECT_CHAR_LIMIT),
  );

export const textArea = yup
  .string()
  .required('Please enter objective')
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LP_PAGE_OBJECTIVE_CHAR_LIMIT),
  );

export const optionalTextArea = yup
  .string()
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LP_PAGE_OBJECTIVE_CHAR_LIMIT),
  );

export const strategies = yup
  .string()
  .optional()
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LC_PAGE_SUBJECT_CHAR_LIMIT),
  );
